import {
  AppDispatch,
  socketConnected,
  startListening,
  State,
} from '@bonanza-social/toolkit/state';
import {
  selectAccountDataState,
  selectAccountMode,
  setAccount,
} from '@bonanza-social/account';
import {
  accountModeReceived,
  accountModeSettled,
  loginPingSent,
  selectAccountModeState,
} from '@bonanza-social/geo-fence/state';
import {
  ACCOUNT_LOAD_TIMEOUT,
  ACCOUNT_MODE_CHANGE_WINDOW,
  ACCOUNT_MODE_CHANGED_EVENT,
  AccountModeChangedEventData,
} from './accountMode.constants';

const isAccountLoaded = (state: State) =>
  selectAccountDataState(state) === 'fulfilled';

const handleAccountModeChanged = (
  dispatch: AppDispatch,
  { mode }: AccountModeChangedEventData,
) => {
  dispatch(setAccount({ mode }));
  dispatch(accountModeReceived({ mode }));
};

startListening({
  actionCreator: socketConnected,
  effect: ({ payload: connection }, { dispatch }) => {
    // The same connection is restarted after the app was in the background,
    // so drop the previous handler before adding it again
    connection.off(ACCOUNT_MODE_CHANGED_EVENT);
    connection.on(
      ACCOUNT_MODE_CHANGED_EVENT,
      (data: AccountModeChangedEventData) => {
        handleAccountModeChanged(dispatch, data);
      },
    );
  },
});

startListening({
  actionCreator: loginPingSent,
  effect: async (_, { dispatch, getState, condition }) => {
    if (!isAccountLoaded(getState())) {
      await condition(
        (__, state) => isAccountLoaded(state),
        ACCOUNT_LOAD_TIMEOUT,
      );
    }

    // A change already arrived (it can beat the ping's own response)
    if (selectAccountModeState(getState()) !== 'waiting') {
      return;
    }

    if (selectAccountMode(getState())) {
      dispatch(accountModeSettled());
      return;
    }

    const isChanged = await condition(
      accountModeReceived.match,
      ACCOUNT_MODE_CHANGE_WINDOW,
    );

    if (!isChanged) {
      dispatch(accountModeSettled());
    }
  },
});
